import type { AlbumResponse, AlbumsResponse } from '@nargus/shared';
import { request } from '../http';

export interface AlbumRef {
  organizationId: string;
  albumId: string;
}

export interface CreateAlbumInput {
  organizationId: string;
  name: string;
}

export interface RenameAlbumInput extends AlbumRef {
  name: string;
}

export const albumResource = {
  list: (organizationId: string): Promise<AlbumsResponse> =>
    request(`/organizations/${organizationId}/albums`),

  get: ({ organizationId, albumId }: AlbumRef): Promise<AlbumResponse> =>
    request(`/organizations/${organizationId}/albums/${albumId}`),

  create: ({ organizationId, name }: CreateAlbumInput): Promise<AlbumResponse> =>
    request(`/organizations/${organizationId}/albums`, {
      method: 'POST',
      body: JSON.stringify({ name }),
    }),

  rename: ({ organizationId, albumId, name }: RenameAlbumInput): Promise<AlbumResponse> =>
    request(`/organizations/${organizationId}/albums/${albumId}`, {
      method: 'PATCH',
      body: JSON.stringify({ name }),
    }),

  remove: ({ organizationId, albumId }: AlbumRef): Promise<void> =>
    request(`/organizations/${organizationId}/albums/${albumId}`, { method: 'DELETE' }),
};
